import {Directive, HostBinding} from '@angular/core'

@Directive({ 
    selector: '[show-hide-input-cam]'
})
export class ShowHideInputCam
{
    @HostBinding() type: string;
     
    constructor(){
        this.type='password';
    }
    
    changeType(type:string): void {
        this.type = type;
    }
}

@Directive({ 
    selector: '[show-hide-input-cam2]'
})
export class ShowHideInputCam2
{
    @HostBinding() type: string;
     
    constructor(){
        this.type='password';
    }
    
    changeType(type:string): void {
        this.type = type;
    }
}

@Directive({ 
    selector: '[show-hide-input-cam3]'
})
export class ShowHideInputCam3
{
    @HostBinding() type: string;
     
    constructor(){
        this.type='password';
    }
    
    changeType(type:string): void {
        this.type = type;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/topnavbar/topnavbar.showhide.ts